/**
 * Header search field behaviour (snippets/nova-search.liquid).
 *
 * The only thing the markup can't do on its own is the clear (⊗) button: a native
 * `type="reset"` empties the field without firing an `input` event, so Boost AI Search's
 * Instant Search widget would keep showing the dropdown for the query the user just
 * cleared. Clearing manually and re-dispatching `input`/`change` keeps Boost in sync,
 * and works the same for the plain-form fallback when Boost isn't loaded.
 *
 * Delegated from the document so the desktop and mobile instances share one listener,
 * and so the handler survives header section re-renders in the theme editor.
 */
document.addEventListener('click', (event) => {
	const clearButton = event.target.closest('.nova-search-form__clear');
	if (!clearButton) return;

	const form = clearButton.closest('.nova-search-form');
	const input = form?.querySelector('.nova-search-input');
	if (!input) return;

	// Prevent the native reset so the value change goes through a single, observable path.
	event.preventDefault();

	if (input.value !== '') {
		input.value = '';
		input.dispatchEvent(new Event('input', {bubbles: true}));
		input.dispatchEvent(new Event('change', {bubbles: true}));
	}

	input.focus();
});
